import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IBlogIconProps extends ISvgIconProps {

}

export class BlogIcon extends React.Component<IBlogIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.183 20.705h18.981"/>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.183 16.923h4.829"/>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.183 13.143h4.829"/>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16.164 16.923h5"/>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.164 13.143h2"/>
                    <g>
                        <path d="m10.268 16.813 2.68-1.851 5.814-8.934a1.4 1.4 0 1 0-2.352-1.514l-5.508 8.834z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    </g>
                </g>
            </SvgIcon>
        );
    }
}
